export default "__VITE_ASSET__Bg1Eh6bW__"